import React from 'react';

import {fmDateTime} from '../common/formatter.jsx';
import {BasicAlert, DDLabel} from '../common/components.jsx';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/css/hCases.css';
import { cssNumber } from 'jquery';
import { NestedDataGrid } from '../common/nestedDataGrid/nestedDataGrid.jsx';
import { get3wViewerLink, is3wAdvUser, isHpExternal } from "../common/utils.js";
import  case_outcomeLogo from '../../int/static/assets/images/case_outcome.png';

class CaseModal extends React.Component {

  handleCloseCaseModal = e => {
    this.props.onClose && this.props.onClose(e);
  };

  handleSubmitCase = e => {
    e.preventDefault();

    const data = {
      legacy_order_no: e.target.legacy_order_no.value,
      web_order_no: e.target.web_order_no.value,
      comments: e.target.threeWCaseComments.value,
      action: e.target.threeWCaseAction.value
    }

    //GEGA TODO AXIOS CALLBACK ASYNC WAIT CLOSE MODAL?
    //var self = this;
    //POST("/os/ossui/v1/in/widgetExpert/case", {data}, function (resp) {
    //    console.log(resp);
    //    self.handleCloseCaseModal();
    //});

    var self = this;
    axios.post('/os/ossui/v1/in/widgetExpert/case', {
      legacy_order_no: e.target.legacy_order_no.value,
      web_order_no: e.target.web_order_no.value,
      comments: e.target.threeWCaseComments.value,
      action: e.target.threeWCaseAction.value
    })
    .then(response => {
      var message = self.props.actionType + " for " + self.props.order.web_order_no + " submitted"
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
      self.handleCloseCaseModal({ currentTarget : {
                                      textContent : null,
                                      value: null,
                                  },
                                });
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
  });

  };

  render() {

    if (!this.props.show) {
      return null;
    }

    var legacy_order_no = this.props.order.legacy_order_no;
    var web_order_no = this.props.order.web_order_no;
    var ship_status = this.props.order.ship_status;
    var payment_method = this.props.order.payment_method;
    var payment_receive_date = this.props.order.payment_receive_date;
    var actionType = this.props.actionType;
    var message = "";

    if (actionType == "cancelation" && ship_status == "FS") {
      message = "You have selected cancelation for a shipped order. This is not possible anymore please initiate a claim if needed."
    } 
    
    if (actionType == "refund") {
      if (payment_method == "Wire") {
        actionType = "refundWire"
        if (payment_receive_date == "") {
          message = "You have selected refund for Wire Payment but order was not paid. Please locate the payment first before refunding. Once done refresh order in OSS for populating the payment receive date."
        }
      } else if (payment_method == "PayPal") {
        actionType = "refundPaypal"
        if (payment_receive_date == "") {
          message = "You have selected refund for PayPal but it appears that money was not taken from customer’s account. Please locate the payment first before refunding. Once done refresh order in OSS for populating the payment receive date."
        }
      } else if (payment_method == "eBayPayments") {
        actionType = "eBayPayments"
        if (payment_receive_date == "") {
          message = "You have selected refund for eBay Payments but it appears that money was not taken from customer’s account. Please locate the payment first before refunding. Once done refresh order in OSS for populating the payment receive date."
        }
      } else if (payment_method == "Klarna") {
        actionType = "refundKlarna"
        if (payment_receive_date == "") {
          message = "You have selected refund for Klarna but it appears that money was not taken from customer’s account. Please locate the payment first before refunding. Once done refresh order in OSS for populating the payment receive date."
        }
      } else if (payment_method == "iDEAL") {
        actionType = "refundIDEAL"
        if (payment_receive_date == "") {
          message = "You have selected refund for iDeal but it appears that money was not taken from customer’s account. Please locate the payment first before refunding.Once done refresh order in OSS for populating the payment receive date."
        }
      } else if (payment_method == "CreditCard") {
        message = "You have selected refund for Credit Card order. We are only charging the customer’s credit card when the order is shipped. No refund needs to be done at this stage."
      } else if (payment_method == "OpenInvoice") {
        message = "You have selected refund for Open Invoice order. For this payment method customer has the possibility to pay in 30 days after he receives the invoice. No refund needs to be done at this stage as we did not invoiced the customer."
      } else {
        message = "Unknown payment type " + payment_method + "! Refund request can not be completed. Please contact OSS Support or OSS SME."
      }
    }


    if (message) {
      toast.warn(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
      message = "";
      this.handleCloseCaseModal({ currentTarget : {
                                  textContent : null,
                                  value: null,
                                  },
                                });
      return null
    }

    return (

      <form className="form-horizontal" onSubmit={this.handleSubmitCase} role="form" id="threeWCaseModalForm" method="post" action="">
        <div className="modal" id="threeWCaseModal" tabIndex="-1" style={{display: "inline"}} role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleCloseCaseModal}>x</button>
                <h3 className="modal-title" id="threeWCaseModalHeading">{this.props.title}</h3>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="col-sm-12">
                    <label>Please type in your comments (will be stored in 3W case):</label>
                    <textarea className="form-control" rows="8" id="threeWCaseComments" name="threeWCaseComments"></textarea>
                    <input className="form-control" type="hidden" id="threeWCaseAction" name="threeWCaseAction" value={actionType}></input>
                    <input className="form-control" type="hidden" id="legacy_order_no" name="legacy_order_no" value={legacy_order_no}></input>
                    <input className="form-control" type="hidden" id="web_order_no" name="web_order_no" value={web_order_no}></input>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-danger">Submit</button>
                <button type="button" onClick={this.handleCloseCaseModal} className="btn btn-info">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

class ThreeWActions extends React.Component {

  state = {
    show: false,
    title: ""
  };

  showCaseModal = e => {
    this.setState({
      show: !this.state.show,
      title: e.currentTarget.textContent,
      actionType: e.currentTarget.value
    });
  };

  render() {
    
    var order = this.props.order;    
    var system = ""

    if (window.location.host.charAt(3) == "-" ) {
      system = window.location.host.substr(3, 4); 
    }

    var claimUrl = "https://eclaims" + system + ".corp.hp.com/ww/eclaims/claimadmin/app?ORDER=" + order.order_no
 
    if ((order.originating_system.match("ISCS") || order.purch_order_type.match("ISCS") || order.purch_order_type.match("MAGE") || order.purch_order_type.match("MAGX") ) && order.om_region == "EMEA" ) {
      if (order.order_overall_status !== "CANCELED") {
        return (
          <div id="3WActions">
            <div id="3WActionButtons" className="btn-toolbar" style={{"display":"inline-block", "paddingTop":"10px"}}>
              <button type="button" className="btn btn-primary btn-sm" onClick={this.showCaseModal} value="cancelation">{T('Order Cancellation')}</button>
              <button type="button" className="btn btn-primary btn-sm" onClick={this.showCaseModal} value="refund">{T('Refund')}</button>
              <button type="button" className="btn btn-primary btn-sm" onClick={this.showCaseModal} value="FundTransferRequest">{T('Fund Transfer')}</button>
              <a className="btn btn-primary btn-sm" href={claimUrl} target="_blank" >{T('Create Claim')}</a> 
            </div>
            <CaseModal onClose={this.showCaseModal} show={this.state.show} title={this.state.title} actionType={this.state.actionType} order={order}/>
          </div>
        ) 
      } else {
        return (
          <div id="3WActions">
            <div id="3WActionButtons" className="btn-toolbar" style={{"display":"inline-block", "paddingTop":"10px"}}>
              <button type="button" className="btn btn-primary btn-sm" onClick={this.showCaseModal} value="refund">{T('Refund')}</button>
              <button type="button" className="btn btn-primary btn-sm" onClick={this.showCaseModal} value="FundTransferRequest">{T('Fund Transfer')}</button>
              <a className="btn btn-primary btn-sm" href={claimUrl} target="_blank" >{T('Create Claim')}</a> 
            </div>
            <CaseModal onClose={this.showCaseModal} show={this.state.show} title={this.state.title} actionType={this.state.actionType} order={order}/>
          </div>
        )
      }
    } else {
      return null;
    }
  }
};

class ShowCases extends React.Component {

  constructor(props) {
    super(props);
  }

  formatData(dataSum, dataDtl, category) {

    var caseNameIdx = 0;
    var fIndex = 6;

    const categoryData = {
      header: dataSum.header
    };
    const childHeader = dataDtl.header

    const groupedByCaseName = {};
    dataSum.data.map(row => {
      const caseName = row[caseNameIdx].props['case_number'];
      groupedByCaseName[caseName] ? groupedByCaseName[caseName].push(row) : groupedByCaseName[caseName] = [row];
      return row;
    });

    categoryData.data = Object.keys(groupedByCaseName).map(groupItem => {
      const currGr = groupedByCaseName[groupItem];
      const currGrData = { data: [] };
      currGr.map(cgItem => {
        const firstRow = currGr[0];
        currGrData.parentRowData = firstRow;
        currGrData.header = childHeader;


        for (var i = 0; i < dataDtl.data.length; i++) {
          if (dataDtl.data[i][fIndex] == cgItem[0].props['case_number'] && currGrData.data.indexOf(dataDtl.data[i]) === -1) {
            currGrData.data.push(dataDtl.data[i]);
          }
        }

        return cgItem;
      })
      return currGrData;
    })

    return categoryData;
  }

  render() {

    var order = this.props.order;

    if (order.cases && order.cases.length > 0) {

      var casesList = order.cases.map( (caseEntry) => {
        if (typeof GlobalUserSettings != 'undefined') { 
            UserSettings.config = GlobalUserSettings.config;
        }
        UserSettings.config = (!UserSettings.config || !UserSettings.config.links) ? this.props.userSettings.config : UserSettings.config;
        var deepLink3W = UserSettings.config.links.MSDyn3WDeepLink + "&id=" + caseEntry.case_instance_id + "&pagetype=entityrecord&etn=incident";

        return (
          <tr>
            <td nowrap><a href={deepLink3W} target="_blank">{caseEntry.case_number}</a></td> 
            <td>{caseEntry.case_parent_id}</td>
            <td>{caseEntry.case_request_source}</td>
            <td>{caseEntry.case_outcome}</td>
            <td>{caseEntry.case_status}</td>  
            <td>{caseEntry.case_process_name}</td> 
            <td>{caseEntry.case_description}</td>
            <td>{caseEntry.case_priority_code}</td>
            <td>{caseEntry.case_material_no}</td>
            <td>{caseEntry.case_category}</td>  
            <td>{caseEntry.case_subcategory}</td>  
            <td>{caseEntry.case_l3category}</td>
            <td>{caseEntry.case_requestor_name}</td>
            <td>{caseEntry.case_requestor_email}</td>
            <td>{caseEntry.case_assigned_to}</td>  
            <td>{caseEntry.case_aquired_by}</td>  
            <td>{fmDateTime(caseEntry.case_update_date)}</td>
            <td>{fmDateTime(caseEntry.case_resolve_by)}</td>
            <td>{caseEntry.priority_index}</td>  
            <td>{caseEntry.shipping_priority}</td> 
           </tr>
          );   
      });  

      var caseEntryData = {
        header: [
          { name: DD('case_number') },
          { name: DD('case_parent_id') },
          { name: DD('case_request_source') },
          { name: DD('case_outcome') },
          { name: DD('case_status') },
          { name: DD('case_process_name') },
          { name: DD('case_description') },
          { name: DD('case_priority_code') },
          { name: DD('case_material_no') },
          { name: DD('case_category') },
          { name: DD('case_subcategory') },
          { name: DD('case_l3category') },
          { name: DD('case_requestor_name') },
          { name: DD('case_requestor_email') },
          { name: DD('case_assigned_to', "osv", "right") },
          { name: DD('case_aquired_by' , "osv", "right") },
          { name: DD('case_update_date', "osv", "right") },
          { name: DD('case_resolve_by' , "osv", "right") },
          { name: DD('case_priority_index') },
          { name: DD('case_shipping_priority') },
        ],
        data: order.cases.map( (caseEntry) => {
          if (typeof GlobalUserSettings != 'undefined') { 
              UserSettings.config = GlobalUserSettings.config;
          }
          UserSettings.config = (!UserSettings.config || !UserSettings.config.links) ? this.props.userSettings.config : UserSettings.config;
          var deepLink3W = UserSettings.config.links.MSDyn3WDeepLink + "&id=" + caseEntry.case_instance_id + "&pagetype=entityrecord&etn=incident";
          var CaseViewer3wLink = get3wViewerLink(UserSettings.config.links.SfdcWorkflowServiceUrl, caseEntry.case_instance_id);
          var selfServicePortal3W = UserSettings.config.links.SelfServicePortal3W + "?id=" + caseEntry.case_instance_id;

          return [
            <span case_number={caseEntry.case_number} style={{whiteSpace: "nowrap", verticalAlign: 'sub'}}>
              {
                UserSettings.user_id && window.SCCPUsers3W?.includes(UserSettings.user_id)
                  ? (
                      <a href={selfServicePortal3W} target="_blank">
                        <i title="Open in 3W Collaboration Portal (license not required)" className="glyphicon glyphicon-new-window" style={{color: '#0096d6', padding: '1px', verticalAlign: 'text-top', marginRight: '5px'}} />
                      </a>
                    )
                  : (
                      <i title="Open in 3W Collaboration Portal (license not required)" className="glyphicon glyphicon-new-window" style={{color: '#bbbbbb', padding: '1px', verticalAlign: 'text-top', marginRight: '5px'}} />
                    )
              }
              <a href={deepLink3W} target="_blank" title="Open in 3W (license required)">{caseEntry.case_number}</a>
            </span>,
            caseEntry.case_parent_id,
            caseEntry.case_request_source,
            caseEntry.case_outcome,
            (<span>{caseEntry.case_status} {caseEntry.case_instructions != "" ? (<img id="caseOutcomeLogo" title= {caseEntry.case_instructions} src = {case_outcomeLogo} height="10px" width="10px" padding-left="10px"/>) : ""}</span>),
            (<span className="ellipsis ewidth-md" title={caseEntry.case_process_name}>{caseEntry.case_process_name}</span>),
            (<span className="ellipsis ewidth-md" title={caseEntry.case_description}>{caseEntry.case_description}</span>),
            caseEntry.case_priority_code,
            caseEntry.case_material_no,
            caseEntry.case_category,
            caseEntry.case_subcategory,
            caseEntry.case_l3category,
            caseEntry.case_requestor_name,
            caseEntry.case_requestor_email,
            caseEntry.case_assigned_to,
            caseEntry.case_aquired_by,
            fmDateTime(caseEntry.case_update_date),
            fmDateTime(caseEntry.case_resolve_by),
            caseEntry.priority_index,
            caseEntry.shipping_priority,
          ]
        })
      };

      var caseCommentData = {};
      var case_comments_per_case = [];
      var case_comments_all = [];
      for (var i = 0; i < order.cases.length; i++) {
        case_comments_per_case = Object.values(order.cases[i].case_comments);
        for (var x = 0; x < case_comments_per_case.length; x++) {
          case_comments_per_case[x].case_number = order.cases[i].case_number
          case_comments_all.push(case_comments_per_case[x]);
        }
      }

      case_comments_all.sort(function(a, b) {
        return Date.parse(a.createdon.substring(0,10)) - Date.parse(b.createdon.substring(0,10));
      });

      caseCommentData = {
        header: [
          { name: DD('subject') },
          { name: DD('notetext') },
          { name: DD('createdon') },
          { name: DD('modifiedon') },
          { name: DD('createdby') },
          { name: DD('modifiedby') },
          { name: DD('case_number'), isHidden:1 },
        ],
        data: case_comments_all.map( (caseEntry) => {
          console.log("GEGA");
          return [
            caseEntry.subject,
            <span class="ellipsis ewidth-md" title={caseEntry.notetext} dangerouslySetInnerHTML={{ __html: caseEntry.notetext }}></span>,
            caseEntry.createdon,
            caseEntry.modifiedon,
            caseEntry.createdby,
            caseEntry.modifiedby,
            caseEntry.case_number,
          ]
        })
      };

      var categoryData = [];
      if (caseCommentData.data.length == 0) {
        categoryData = caseEntryData;
      } else {
        categoryData = this.formatData(caseEntryData, caseCommentData);
      }

      return (
        <div className="casesOverview">
          <NestedDataGrid
            id="nestedCasesOverview"
            enableDownload={false}
            header={categoryData.header}
            data={categoryData.data}
            isExpanded={false}/>
        </div>
      )

    } else {
      return <BasicAlert type='N' />
    }
  }
};

//----------------------------------------------------------------------
//   hCases -- show header level order informations
//
//----------------------------------------------------------------------
export class Cases extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    var order = this.props.order;

    return (
      <div id="hCases">
        <ShowCases order={order}/>
        <ThreeWActions order={order}/>
      </div>
    )
  }
};
